export const validateOwnerRegistration = (formData) => {
  const errors = {};

  // Validate Vendor Name
  if (!formData.ownerName || formData.ownerName.trim().length < 1) {
    errors.ownerName = "Business name is required.";
  } else if (formData.ownerName.length > 50) {
    errors.ownerName = "Business name cannot exceed 50 characters.";
  }

  // Validate Phone Number
  if (!formData.phoneNo || formData.phoneNo.trim().length < 1) {
    errors.phoneNo = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.phoneNo)) {
    errors.phoneNo =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // Validate Password
  if (!formData.password || formData.password.trim().length < 6) {
    errors.password = "Password must be at least 6 characters long.";
  } else if (
    !/(?=.*\d)(?=.*[@#$%^&+=_])(?=.*[A-Za-z])/.test(formData.password)
  ) {
    errors.password =
      "Password must contain at least one letter, one number, and one special character.";
  } else if (formData.password.length > 30) {
    errors.password = "Password cannot exceed 30 characters.";
  }

  return errors;
};
